var map = {
	"./abc-news-au.png": "2N81",
	"./abc-news.png": "k5dj",
	"./aftenposten.png": "lxlY",
	"./al-jazeera-english.png": "AiFx",
	"./ansa.png": "0ZHF",
	"./argaam.png": "3Ph2",
	"./ars-technica.png": "GLjX",
	"./ary-news.png": "KciX",
	"./associated-press.png": "n71P",
	"./australian-financial-review.png": "gk/y",
	"./axios.png": "bcln",
	"./bbc-news.png": "MC/H",
	"./bbc-sport.png": "M2YU",
	"./bild.png": "sjDK",
	"./blasting-news-br.png": "MVfM",
	"./bleacher-report.png": "RpF5",
	"./bloomberg.png": "VKx2",
	"./breitbart-news.png": "3tcP",
	"./business-insider-uk.png": "gbIt",
	"./business-insider.png": "hM2q",
	"./buzzfeed.png": "Liaa",
	"./cbc-news.png": "O84T",
	"./cbs-news.png": "kVlV",
	"./cnbc.png": "5+r2",
	"./cnn-es.png": "pXMg",
	"./cnn.png": "ZwO2",
	"./crypto-coins-news.png": "c0Ch",
	"./daily-mail.png": "O7/5",
	"./der-tagesspiegel.png": "Y6EZ",
	"./die-zeit.png": "nI9R",
	"./el-mundo.png": "fUU8",
	"./engadget.png": "k9TQ",
	"./entertainment-weekly.png": "5PBb",
	"./espn-cric-info.png": "h+Xu",
	"./espn.png": "N1Of",
	"./financial-post.png": "51eL",
	"./financial-times.png": "m/Jm",
	"./focus.png": "PP6d",
	"./football-italia.png": "hsp0",
	"./fortune.png": "b1H/",
	"./four-four-two.png": "BNkB",
	"./fox-news.png": "yJqh",
	"./fox-sports.png": "8OIH",
	"./globo.png": "gGn/",
	"./google-news-ar.png": "f3fg",
	"./google-news-au.png": "kTET",
	"./google-news-br.png": "ZQ25",
	"./google-news-ca.png": "1nEF",
	"./google-news-fr.png": "xArn",
	"./google-news-in.png": "UtEW",
	"./google-news-it.png": "LNcH",
	"./google-news-ru.png": "S1aL",
	"./google-news-sa.png": "VOPv",
	"./google-news-uk.png": "i+5X",
	"./google-news.png": "CbKj",
	"./goteborgs-posten.png": "OT+U",
	"./gruenderszene.png": "XUtq",
	"./hacker-news.png": "wBdP",
	"./handelsblatt.png": "rN7t",
	"./ign.png": "PVgS",
	"./il-sole-24-ore.png": "lziP",
	"./independent.png": "VkdU",
	"./info-money.png": "ymdH",
	"./infobae.png": "+Q9R",
	"./la-gaceta.png": "lpRV",
	"./la-nacion.png": "/0tA",
	"./la-repubblica.png": "nMuT",
	"./le-monde.png": "IJ8n",
	"./lenta.png": "T0Eq",
	"./lequipe.png": "V0R5",
	"./les-echos.png": "eOFQ",
	"./liberation.png": "r3Xd",
	"./marca.png": "53eL",
	"./mashable.png": "tdFP",
	"./medical-news-today.png": "WJjn",
	"./metro.png": "J3Gw",
	"./mirror.png": "qiJZ",
	"./msnbc.png": "auYY",
	"./mtv-news-uk.png": "KLce",
	"./mtv-news.png": "0nb1",
	"./national-geographic.png": "J7+o",
	"./national-review.png": "QO71",
	"./nbc-news.png": "CDvt",
	"./new-scientist.png": "vYvH",
	"./new-york-magazine.png": "49Kz",
	"./news-com-au.png": "gSId",
	"./news24.png": "9mMu",
	"./newsweek.png": "3ES6",
	"./next-big-future.png": "SS88",
	"./nfl-news.png": "vaVJ",
	"./nhl-news.png": "Sewi",
	"./nrk.png": "qtrS",
	"./politico.png": "+EZ8",
	"./polygon.png": "VBpk",
	"./rbc.png": "tCj0",
	"./recode.png": "XGRp",
	"./reddit-r-all.png": "DOZR",
	"./reuters.png": "JlDH",
	"./rt.png": "CGbd",
	"./rte.png": "6yfc",
	"./rtl-nieuws.png": "fyv3",
	"./sabq.png": "KVr6",
	"./sevenska-dagbladet.png": "NJXx",
	"./spiegel-online.png": "XvNk",
	"./t3n.png": "XWI8",
	"./talksport.png": "iQ9N",
	"./techcrunch-cn.png": "pgAv",
	"./techcrunch.png": "iSr8",
	"./techradar.png": "Va0f",
	"./the-american-conservative.png": "XVGi",
	"./the-economist.png": "ugzc",
	"./the-globe-and-mail.png": "yoFF",
	"./the-guardian-au.png": "PthO",
	"./the-guardian-uk.png": "jMJK",
	"./the-hill.png": "UYmS",
	"./the-hindu.png": "hmh8",
	"./the-huffington-post.png": "JDec",
	"./the-irish-times.png": "cA0M",
	"./the-jerusalem-post.png": "bRF4",
	"./the-lad-bible.png": "FpHX",
	"./the-new-york-times.png": "eWVB",
	"./the-next-web.png": "YQGl",
	"./the-sport-bible.png": "68ec",
	"./the-telegraph.png": "pe9U",
	"./the-times-of-india.png": "SFQs",
	"./the-verge.png": "dVFt",
	"./the-wall-street-journal.png": "Z6Ep",
	"./the-washington-post.png": "wzhm",
	"./the-washington-times.png": "e44i",
	"./time.png": "L7xM",
	"./usa-today.png": "jhXI",
	"./vice-news.png": "AxuY",
	"./wired-de.png": "41Ux",
	"./wired.png": "heNQ",
	"./wirtschafts-woche.png": "+Bzo",
	"./xinhua-net.png": "yI0a",
	"./ynet.png": "FMSL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 0